@import (reference) '../../constants/spacing.module.less';

.edit-columns-button-container {
  padding: 9px 20px 0 0;
}

.plan-features-trial-upsell-banner {
  margin: @space-20 0 @space-16 @space-16;
}
